import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { environment } from "../../../environments/environment";
import { DatePipe } from "@angular/common";
import { FormatService } from '~/services/administration.ts/format';
import { ThemeService } from '@progress/kendo-angular-charts';

@Pipe({
    name: 'dateFormat',
    standalone: false
})

export class DateFormatPipe extends DatePipe implements PipeTransform {

  _model:any;

  constructor(@Inject(LOCALE_ID) locale: string,
              private _formatService: FormatService,
              ){
    super(locale);
  }

  transform(value: any, args?: any): any {
    try {
      this._model = this._formatService.dateFormat;
       return super.transform(value,this._model);
    } catch (error) {        
    return value
    }
 
  }
}
